<template>
  <div class="sidebar-box p-2">
    <h6 v-t="`filter.category.title`"></h6>
    <category v-model="selectedCategories" v-for="category in categories" :category-column="categoryColumn"
              :key="category.id" :category="category"/>
  </div>
</template>

<script>
import Category from './Category'
import {flatCategories} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Category'

export default {
  name: "FilterCategory1",
  components: {Category},
  props: {
    categoryColumn: {
      default: 'id',
      validator(value) {
        // The value must match one of these strings
        return ['id', 'slug'].includes(value)
      }
    },
    productCategories: {
      default: null
    },
    categories: {
      default:[]
    },
  },
  data() {
    return {
      selectedCategories: [],
      activeWatcher: false
    }
  },
  methods: {
    flatCategories,
    getCategoryIds() {
      let ids = []
      this.flatCategories(this.categories).forEach(item => {
        if (this.selectedCategories.indexOf(item.id) > -1) {
          ids.push(item.id)
        }
      })
      return ids.length > 0 ? ids : null
    },
    getCategorySlugs() {
      let slugs = []
      this.flatCategories(this.categories).forEach(item => {
        if (this.selectedCategories.indexOf(item.slug) > -1) {
          slugs.push(item.slug)
        }
      })
      return slugs.length > 0 ? slugs : null
    },
    filterOutput() {
      if (this.categoryColumn === 'id') {
        return this.getCategoryIds();
      }
      if (this.categoryColumn === 'slug') {
        return this.getCategorySlugs();
      }
    },
    emitData() {
      let data = {
        categories: this.filterOutput(),
        categoriesObject: this.selectedCategories,
        categoriesObjectRaw: this.categories,
      }
      this.$emit('categories', data)
    }
  },
  async mounted() {
    if (this.productCategories != null) {
      this.selectedCategories = this.productCategories
    }
    this.activeWatcher = true
  },
  watch: {
    selectedCategories: {
      handler(oldValue, newValue) {
        if (this.activeWatcher && this.$route.query.category === undefined) {
          this.emitData()
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.sidebar-box {
  border-radius: 10px;
  background: white;
  box-shadow: 0px 5px 25px rgba(218, 211, 211, 0.3);
  margin-bottom: 30px;
  border: 1px solid #F5F4F4;
}
</style>